let requireApis = require.context(
  './modules', // 在当前目录下查找
  true, // 不遍历子文件夹
  /\.js$/ // 正则匹配 以 .js结尾的文件
)

//动态注入api
var dynamicApis = {}
requireApis.keys().map(key => {
  // requireApis[]
  // 注册组件名称
  const da = requireApis(key).default || {}
  Object.keys(da).forEach(key => {
    dynamicApis[key] = da[key]
  })
})
const apis = {
  //公共接口api
  common: {
    getIndustryTree: "/api/common/getIndustryTree",
    sessionLogin: "/sessionLogin",
    getToken: "/api/tokenManage/getToken",
    checkToken: "/api/tokenManage/checkToken",
    doLogin: '/doLogin',
    doLoginWithCaptcha: '/doLoginWithCaptcha',
    getWeather: '/api/weather/getWeather',
    getPaperTypesOptions: '/api/acommon/getPaperTypesOptions',
    getSystemRole: '/api/acommon/getSystemRole',
    getICTypes: '/api/acommon/getICTypes',
    getFullICTypes: '/api/acommon/getFullICTypes',
    // getDataSourceOptions: '/api/acommon/getDataSourceOptions',
    //获取所有菜单 没有权限显示
    getFullMenus: '/getFullMenus',
    getKnowledge: '/share/getKnowledge',
    satisfactionResultOptions: 'api/satisfactionCommon/satisfactionResultOptions',
    evaluationDimensionOptions: 'api/satisfactionCommon/evaluationDimensionOptions',
    satisfactionLog: 'api/satisfactionCommon/satisfactionLog',
    getAPPDownloads: 'appBaseSupport/getAPPDownloads',
    getFBS: '/api/acommon/getFBS',
  },
  ...dynamicApis
}

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, "$apis", { value: apis })
  },
}
